/**
 * @fileoverview Telegram Mini App 自动登录组件
 * @description 在 TG Mini App 环境中，应用启动时自动执行登录流程
 * 非 TG 环境下此组件不做任何事情
 * MVC 架构：Controller 层组件
 * @module components/TelegramAutoLogin
 */
import { useEffect, useRef } from 'react';
import { useLocation } from 'wouter';
import { useAppStore } from '../stores/useAppStore';
import { useTelegramLogin } from '../hooks/useTelegramLogin';
import { initTelegramApp, isTelegramMiniApp } from '../lib/telegram';
import { toast } from 'sonner';

/**
 * Telegram Mini App 自动登录组件
 * @description
 * - 在 TG 环境中：初始化 TG WebApp，检测登录状态，未登录则自动登录
 * - 在普通浏览器中：不做任何操作
 */
export default function TelegramAutoLogin() {
  const { isAuthenticated, loginWithWallet } = useAppStore();
  const { loginWithTelegram, isTgEnvironment } = useTelegramLogin();
  const [, navigate] = useLocation();
  const hasAttempted = useRef(false);

  useEffect(() => {
    // 非 TG 环境，跳过
    if (!isTelegramMiniApp()) return;

    // 初始化 TG WebApp（ready + expand + 主题色）
    initTelegramApp();

    // 已登录，跳过
    if (isAuthenticated) return;

    // 防止重复触发
    if (hasAttempted.current) return;
    hasAttempted.current = true;

    // 自动执行 TG 登录
    const doLogin = async () => {
      const loginData = await loginWithTelegram();
      if (loginData) {
        await loginWithWallet(loginData);
        // 登录成功后跳转到首页
        navigate('/');
      } else {
        toast.error('Telegram 登录失败，请重试');
      }
    };

    doLogin();
  }, [isAuthenticated, isTgEnvironment, loginWithTelegram, loginWithWallet, navigate]);

  // 此组件不渲染任何 UI
  return null;
}
